<script setup>
// Full-screen "we're taking you to Polar" indicator. The checkout/portal
// redirect is a full page navigation with a noticeable pause — without this
// the click appears to do nothing (the only hint was the browser tab).
import { Loader2, ShieldCheck } from 'lucide-vue-next'

defineProps({
  show: { type: Boolean, default: false },
  label: { type: String, default: 'Opening secure checkout…' },
})
</script>

<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-150 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
    >
      <div
        v-if="show"
        class="fixed inset-0 z-[70] flex flex-col items-center justify-center gap-4 bg-slate-950/70 text-white backdrop-blur-sm"
        role="status"
        aria-live="polite"
      >
        <Loader2 class="h-10 w-10 animate-spin text-teal-400" />
        <p class="text-lg font-semibold">{{ label }}</p>
        <p class="flex items-center gap-1.5 text-sm text-slate-300">
          <ShieldCheck class="h-4 w-4 text-teal-400" /> Payments handled securely by Polar
        </p>
      </div>
    </Transition>
  </Teleport>
</template>
